import React from 'react';

const Login = () => {
  const handleCasdoorLogin = () => {
    const casdoorEndpoint = process.env.REACT_APP_CASDOOR_ENDPOINT || 'https://your-casdoor.com';
    const clientId = process.env.REACT_APP_CASDOOR_CLIENT_ID || 'your-client-id';
    const redirectUri = encodeURIComponent(window.location.origin + '/auth/callback');
    const state = Math.random().toString(36).substring(7);

    sessionStorage.setItem('auth_state', state);

    const loginUrl = `${casdoorEndpoint}/login/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&state=${state}&scope=profile%20email`;

    window.location.href = loginUrl;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            ADA QR Cevap Sistemi
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            ADA Hızlı cevap paylaşım platformu
          </p>
        </div>

        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">
                Giriş Yapın
              </h3>
              <p className="text-sm text-gray-600 mb-6">
                Sisteme giriş yapmak için ADA Ortak Giriş hesabınızı kullanın
              </p>
            </div>

            <button
              onClick={handleCasdoorLogin}
              className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              ADA ile Giriş Yap
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
